export default __webpack_public_path__ + "boogo_discount-percent.8ede3571.svg";